import { Toast } from '@/presentation/helper';

const notify = new Toast().showToast;

export default notify;
